<template>
  <div>
    <ECharts :options="connectivityOptions" :autoresize="true"/>
  </div>
</template>

<script>
/* eslint-disable */

import ECharts from "vue-echarts";
import "echarts/lib/chart/graph";

export default {
  name: "App",
  data() {
    return {
      canvasSize: 0,
    };
  },
  components: { ECharts },
  created() {
  },
  computed: {
  },
  created() {


    console.table(this.$store.state.main.allPlayers)


    const players = this.$store.state.main.allPlayers;

    let nodes = []

    for (let i = 0; i < players.length; i++) {
      const newNode = {
        name: players[i].nick_name
      }

      nodes.push(newNode)
    }

    const nominations = this.$store.state.main.nominations;

    console.table(nominations)

    let links = []

    for (let i = 0; i < nominations.length; i++) {

      const sourceIndex = nominations[i].player;
      const targetIndex = nominations[i].nominee;
      const source = players[sourceIndex].nick_name;
      const target = players[targetIndex].nick_name;


      const newLink = {
        source: source,
//        target: target
        target: source
      }
      links.push(newLink)
    }
console.table(nodes)
  console.table(links)

    this.connectivityOptions = {
      animation: false,
        series : [
            {
                type: 'graph',
                layout: 'force',
                data: nodes,
                links: links,
                force: {
                    repulsion: 100
                },
                animation: false
            }
        ]
    };

  },
  methods: {
  }
}
</script>
